import React from 'react';
import styled from 'styled-components';
import { media } from '../../ui-components/styles/media';


const Spacer = props => {
  const { children, padding} = props;

  return (
    <SpaceWrapper padding={padding}>
      {children}
    </SpaceWrapper>
  );
};


const SpaceWrapper = styled.div`
    padding: ${({ padding }) => (padding ? padding : '80px 0px;')};

    @media only screen and (max-width: ${media.mediumTop}) {
      padding: 0 0;
    }
`;

export { Spacer };
